<template>
  <v-row>
    <v-col cols="12" class="mx-auto" submission_requests>
      <v-card class="elevation-0" :loading="loading">
        <Paging 
          :resourceSettings="resourceSettings" 
          :resource="submission_requests" 
          @loadResource="loadResource"
          @pageByNumber="pageByNumber" />
        <v-card-text>
          <v-row class="row">
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Type"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="type"
                  :items="types"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" class="mx-auto">
              <v-btn block @click.prevent="dialog = true" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="submission_requests.data && submission_requests.data.length > 0" >
            <v-col cols="12" v-for="(submission, s) in submission_requests.data" :key="'sub-' + s" class="elevation-1 mb-2 py-0">
              <v-row class="align-center">
                <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`">
                  <div :class="`${arabic?'arFont':'enFont'}`">{{ i18n["request_title"] }}</div>
                  <div :class="`${arabic?'arFont':'enFont'}`">{{submission.request}}</div>
                </v-col>
                <v-col cols="12" md="3" class="ml-auto">
                  <v-chip v-if="!submission.submission"  color="error" :class="`${arabic?'arFont':'enFont'} mx-2`">{{ i18n.pending }}</v-chip>
                  <v-chip v-if="submission.submission"  color="success" :class="`${arabic?'arFont':'enFont'} mx-2`">{{ i18n.submited }}</v-chip>
                </v-col>
                <v-col cols="12" md="3" class="ml-auto">
                  <v-btn small color="primary" @click.prevent="editResource(submission)">Edit</v-btn>
                  <v-btn small color="error" class="ml-2" @click.prevent="triggerDelete(submission)">Delete</v-btn>
                </v-col>
              </v-row>
              <v-divider v-if="submission.submission"></v-divider>
              <v-row class="align-center" v-if="submission.submission">
                <v-col cols="12" md="12" >
                  <div :class="`${arabic?'arFont':'enFont'}`">{{ i18n["already_submited"] }}</div>
                  <div v-if="!submission.submission.includes('https://')" :class="`${arabic?'arFont':'enFont'}`">{{ submission.submission }}</div>
                  <div v-else><a target="_blank" :href="submission.submission" :class="`${arabic?'arFont':'enFont'}`">{{ i18n["submited_review"] }}</a></div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <SubmissionRequestDialog
      :loading="loading"
      :dialog="dialog"
      :resource="resource"
      @closeDialog="() => (dialog = false)"
      @saveResource="saveResource"
    />

    <multiDialog
      :dialog="multi_dialog" 
      :newResource="resource"
      :loading="loading"
      :deleting="deleting"
      :resourceSettings="resourceSettings"
      :resourceKeys="[]"
      @closeDialog="
        () => {
          multi_dialog = false;
        }
      "
      @deleteResource="deleteResource"
    />
  </v-row>
</template>

<script>
import Paging from '@/components/Paging'
import SubmissionRequestDialog from './submissionRequestDialog.vue';
import multiDialog from "../multiDialog.vue";

export default {
  components: { Paging, SubmissionRequestDialog, multiDialog },
  props: ['submission_requests', 'candidate'],
  data() {
    return {

      page: 1, 

      types: [
        { text: "All", value: null },
        { text: "Text", value: "text" },
        { text: "Number", value: "number" },
        { text: "Textarea", value: "textarea" },
        { text: "Switch", value: "switch" },
        { text: "Upload", value: "upload" },
      ],

      // @s filters
      type: null,
      // @e filters

      loading: false,
      deleting: false,
      dialog: false,
      multi_dialog: false,
      resource: {},
			resourceSettings: {
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
    }
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.type) {
        filter += `&type=${this.type}`
      }

      return filter;
    },
    applyFilter() {
      this.loadResource()
    },
    triggerDelete(r) {
      this.resourceSettings.resourceName = 'submission_requests'
      this.resource = r
      this.deleting = true
      this.multi_dialog = true
    },
    editResource(r) {
      this.resource = {...r}
      this.dialog = true
    },
    async saveResource(r) {
      this.loading = true
      if (!r.id) {
        await this.$store.dispatch('postResource', {resource: '/can/create_/submission_requests', value: {...r, candidate_id: this.candidate.id}})
      }
      else {
        await this.$store.dispatch('putResource', {resource: `/can/update_/submission_requests/${r.id}`, value: r})
      }
      this.loading = false

      this.resource = {}
      this.dialog = false

      this.loadResource()
    },
    async deleteResource(r) {
      await this.$store.dispatch('deleteResource', {resource: `/can/delete_/submission_requests/${r.id}`})
    },
    loadResource() {
      this.$emit('loadResource', 'submission_requests', 'submission_requests', this.buildFilter(), this.page)
    },
    pageByNumber(page) {
      this.page = page
      this.$emit('pageByNumber', 'submission_requests', 'submission_requests', page)
    },
  }
}
</script>